import logo from "../../assets/logoDark.svg";
import modeIcon from "../../assets/modeIconDark.svg";
import heartLike from "../../assets/heartLikeDark.svg";

// eslint-disable-next-line
export default {
  title: "dark",

  colors: {
    background: "#12482E",
    card: "#082115",
    separetor: "#71E025",
    detail: "#71E025",
    title: "#FAFAFA",
    text: "#FAFAFA",
    buttonText: "#FAFAFA",
    date: "#70E864",
  },
  logo: logo,
  mode: {
    icon: modeIcon,
    text: "Light Mode",
  },
  heartLike: heartLike,
};
